import styled from "styled-components";
import { portalColors } from "src/components";

export const Table = styled.table`
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    box-shadow: ${portalColors.shadow};
    border-radius: 7px;
    border: 1px solid ${portalColors.border};
    overflow: hidden;
`;

export const TH = styled.th`
    text-align: left;
    padding: 12px;
    font-weight: 600;
    border: 1px solid ${portalColors.border};
    font: normal normal bold 14px/16px Manrope;
    letter-spacing: 0px;
    padding: 12px 16px;
    height: 35px;
`;

export const TD = styled.td`
    padding: 12px;
    border-bottom: 1px solid #e0e0e0;
    border: 1px solid ${portalColors.border};
    text-align: left;
    font: normal normal 500 14px/16px Manrope;
    letter-spacing: 0px;
    padding: 12px 16px;
    height: 40px;
`;

export const ViewEditButton = styled.button`
    width: 101px;
    height: 32px;
    background: ${portalColors.surface};
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid ${portalColors.text};
    border-radius: 7px;
    opacity: 1;
    font-size: 0.875rem;
    cursor: pointer;
    color: ${portalColors.text};    
`;

export const CreateRoleButton = styled.button`
    width: 206px;
    height: 38px;
    background: ${portalColors.text};
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 7px;
    border: 1px solid ${portalColors.text};
    color: #fff;
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
    &:hover {
        opacity: 0.9;
    }
`;
